type MaybePromise<T> = T | Promise<T>;

export const createBufferedCollector = <T>(fn: (ids: T[]) => MaybePromise<void>, intervalMs: number) => {
  let timer: ReturnType<typeof setTimeout> | null = null;
  const dataList = new Set<T>();

  const flush = async () => {
    if (dataList.size === 0) {
      timer = null;
      return;
    }

    const batch = [...dataList];
    dataList.clear();

    timer = setTimeout(() => {
      flush();
    }, intervalMs);

    await fn(batch);
  };

  return {
    push: (data: T) => {
      dataList.add(data);

      if (!timer) {
        timer = setTimeout(() => {
          flush();
        }, intervalMs);
      }
    },

    flushNow: async () => {
      if (timer) {
        clearTimeout(timer);
        timer = null;
      }

      if (dataList.size === 0) return;

      const batch = [...dataList];
      dataList.clear();

      await fn(batch);
    },

    cancel: () => {
      if (timer) {
        clearTimeout(timer);
        timer = null;
      }

      dataList.clear();
    },
  };
};
